import { jsx } from "@emotion/react/jsx-runtime";
import { useSsr } from "usehooks-ts";
import { Fragment } from "react";
function ClientOnly(_ref) {
  let {
    fallback = null,
    children
  } = _ref;
  const {
    isBrowser
  } = useSsr();
  if (!isBrowser) {
    return fallback;
  }
  return /* @__PURE__ */jsx(Fragment, {
    children
  });
}
export { ClientOnly as default };